"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asPendingImpact = exports.asBorrowAction = exports.asBorrowMethod = void 0;
const sanitizers_1 = require("@restless/sanitizers");
exports.asBorrowMethod = (0, sanitizers_1.asEnum)(['repay', 'borrow', 'deposit', 'withdraw'], 'BorrowMethod');
exports.asBorrowAction = (0, sanitizers_1.asObject)({
    method: exports.asBorrowMethod,
    amount: sanitizers_1.asString,
    decimals: sanitizers_1.asNumber,
    asset: sanitizers_1.asString,
    transactionId: sanitizers_1.asString,
    timestamp: sanitizers_1.asNumber,
    blockNumber: sanitizers_1.asNumber,
});
exports.asPendingImpact = (0, sanitizers_1.asObject)({
    account: sanitizers_1.asString,
    actions: (0, sanitizers_1.asArray)(exports.asBorrowAction),
});
//# sourceMappingURL=asBorrow.js.map